import Vue from 'vue'
const vue = new Vue();
// 通知-服务
export default {
  /**
   * 广播
   * 
   * @param name  名称
   * @param value 值
   */
  emit(name, value) {
    vue.$emit(name, value);
  },
  /**
   * 监听
   * 
   * @param name 名称
   * @param callback 回调
   */
  on(name, callback) {
    vue.$on(name, res => {
      if (callback) callback(res);
    });
  },
  /**
   * 取消监听
   * 
   * @param name 名称
   */
  off(name) {
    vue.$off(name);
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/notification.js